import { render, staticRenderFns } from "./ProductIsAmazing.vue?vue&type=template&id=6610b7aa"
import script from "./ProductIsAmazing.vue?vue&type=script&lang=js"
export * from "./ProductIsAmazing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports